import { useTranslation } from 'react-i18next';
import { DIALOG } from 'constants/dialog';
import { LogoEzToTrade } from 'assets/icons';
import { useStore } from 'stores';
import useGoogle from 'hooks/useGoogle';

export default function Header() {
  const { t } = useTranslation();
  const isTrail = useStore((state) => state.isTrail);
  const isLogin = useStore((state) => state.isLogin);
  const openDialog = useStore((state) => state.openDialog);
  const logout = useStore((state) => state.logout);
  const trailLogin = useStore((state) => state.trailLogin);

  const { signOut } = useGoogle({});

  function onLogout() {
    // 直接登出
    logout();

    if (!isTrail) {
      // 社群登出
      signOut();
    }
  }

  function handleLoginClick() {
    openDialog(DIALOG.socialLogin);
  }

  return (
    <div className="fixed top-0 left-0 flex px-4 py-3 items-center shadow-lg h-14 bg-white w-full justify-between">
      <LogoEzToTrade className="h-full w-5/12" />

      {isLogin ? (
        <div>
          <button
            className="border border-1 rounded-lg border-blue text-blue font-bold h-8 px-3 mx-2"
            onClick={onLogout}
          >
            {t('Header.logout')}
          </button>
        </div>
      ) : (
        <div>
          <button
            className="border border-1 rounded-lg border-blue text-blue font-bold h-8 px-3 mx-2"
            onClick={handleLoginClick}
          >
            {t('Header.login')}
          </button>
          <button className="rounded-lg bg-blue text-white font-bold h-8 px-3" onClick={trailLogin}>
            {t('Header.tryOn')}
          </button>
        </div>
      )}
    </div>
  );
}
